// Silkway Shopify Theme JS
(function () {
  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-silk-mobile-toggle]');
    if (toggle) {
      var menu = document.querySelector('[data-silk-mobile-menu]');
      if (menu) {
        var open = menu.getAttribute('data-open') === 'true';
        menu.setAttribute('data-open', open ? 'false' : 'true');
      }
    }
  });

  // Simple scroll reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '-40px 0px', threshold: 0.1 });
    document.querySelectorAll('[data-silk-reveal]').forEach(function (el) { io.observe(el); });
  }

  // Header background on scroll
  var header = document.querySelector('.silk-header');
  if (header) {
    var onScroll = function () {
      header.setAttribute('data-scrolled', window.scrollY > 8 ? 'true' : 'false');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
